"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _axios = _interopRequireDefault(require("axios"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactComponents = require("@cimpress/react-components");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var UIWrappedLink =
/*#__PURE__*/
function (_Component) {
  _inherits(UIWrappedLink, _Component);

  function UIWrappedLink(props) {
    var _this;

    _classCallCheck(this, UIWrappedLink);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(UIWrappedLink).call(this, props));
    _this.mounted = true;
    _this.state = {
      status: props.t('checking')
    };
    return _this;
  }

  _createClass(UIWrappedLink, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.verifyLink();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.href !== prevProps.href) {
        this.verifyLink();
      }
    }
  }, {
    key: "statusCodeToState",
    value: function statusCodeToState(statusCode) {
      var _this2 = this;

      var t = this.props.t;

      switch (statusCode.toString()) {
        case '200':
          return 'OK';

        case '202':
          setTimeout(function () {
            return _this2.verifyLink();
          }, 500);
          return t('in_progress');

        case '401':
        case '403':
          return t('no_access');

        default:
          return 'N/A (' + statusCode + ')';
      }
    }
  }, {
    key: "verifyLink",
    value: function verifyLink() {
      var _this3 = this;

      var t = this.props.t;

      if (!t) {
        t = function t(a) {
          return a;
        };
      }

      if (!this.mounted) {
        return;
      }

      this.setState({
        status: t('checking')
      }, function () {
        return _axios["default"].get(_this3.props.href, {
          headers: {
            'Authorization': "Bearer ".concat(_this3.props.accessToken)
          }
        }).then(function (response) {
          if (_this3.mounted) {
            _this3.setState({
              status: _this3.statusCodeToState(response.status)
            });
          }
        })["catch"](function (error) {
          if (_this3.mounted) {
            _this3.setState({
              status: _this3.statusCodeToState((error.response || {
                status: 'Unknown'
              }).status)
            });
          }
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var t = this.props.t;

      if (this.state.status !== 'OK' && !this.props.noPreCheck) {
        return _react["default"].createElement("div", {
          style: {
            display: 'inline'
          }
        }, _react["default"].createElement(_reactComponents.Tooltip, {
          contents: this.state.status
        }, this.props.title || this.props.filename || t('download')));
      }

      var campaign = 'utm_source=ids&utm_medium=idm&utm_campaign=invoice&utm_content=text';
      var headersQueryParam = '';

      if (this.props.isPdf) {
        headersQueryParam = '&headers=%7B%22accept%22%3A%22application%2Fpdf%22%7D';
      }

      return _react["default"].createElement("a", {
        href: "https://uiwrap.trdlnk.cimpress.io/?".concat(campaign, "&url=").concat(this.props.href, "&filename=").concat(this.props.filename).concat(headersQueryParam),
        target: '_blank'
      }, this.props.title || this.props.filename || t('download'));
    }
  }]);

  return UIWrappedLink;
}(_react.Component);

exports["default"] = UIWrappedLink;
UIWrappedLink.propTypes = {
  t: _propTypes["default"].func.isRequired,
  href: _propTypes["default"].string.isRequired,
  accessToken: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  filename: _propTypes["default"].string,
  isPdf: _propTypes["default"].bool,
  noPreCheck: _propTypes["default"].bool
};
UIWrappedLink.defaultProps = {
  noPreCheck: false
};